import type { TeaserCardProps } from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import {
  TeaserSplit,
  TeaserSplitProps,
} from '@bonniernews/dn-design-system-web/components/teaser-split/teaser-split.tsx'

interface TeaserSplitContainerProps extends Omit<TeaserCardProps, 'children'> {
  areaType?: 'main' | 'bauta'
  teasers: TeaserSplitProps[]
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-split](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-split-container)
 * - Storybook: [TeaserSplit](https://designsystem.dn.se/?path=/docs/section-teasersplit-teasersplitcontainer--docs)
 */
export const TeaserSplitContainer = ({
  areaType,
  theme,
  teasers,
  classNames,
  attributes,
}: TeaserSplitContainerProps) => {
  const componentClassName = 'ds-split-container'

  const classes = formatClassString([
    componentClassName,
    areaType === 'bauta' && `${componentClassName}--bauta`,
    theme && `ds-theme--${theme}`,
    classNames,
  ])

  return (
    <div className={classes} {...attributes}>
      {teasers.map((teaser) => (
        <TeaserSplit {...teaser} areaType={areaType} />
      ))}
    </div>
  )
}
